import { useProfile } from "modules/common";
import { Navigate } from "react-router-dom";

import { PrivilegeCheckerProps } from "./PrivilegeChecker.types";

const PrivilegeChecker = ({
  children,
  necessaryPrivilege
}: PrivilegeCheckerProps): JSX.Element => {
  const { user } = useProfile({ enabled: false });

  if (user.role !== "Moderator") {
    return children;
  }

  return user.privileges.includes(necessaryPrivilege) ? (
    children
  ) : (
    <Navigate to="/no-access" />
  );
};

export default PrivilegeChecker;
